import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  ref: "map",
  class: "h-100"
}
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("iframe", {
      class: "w-100 h-100",
      loading: "lazy",
      allowfullscreen: "",
      style: {"border":"0"},
      src: _ctx.url
    }, null, 8, _hoisted_2)
  ], 512))
}